import { setActiveMenuTier } from './nav-mobile'

const ANIMATION_DURATION = 100
const KEYCODE_ESC = 27

const SELECTORS = {
  BTN_MENU: '#HeaderMobile__MenuBtn',
  MENU_WRAP: '#NavMobileWrap',
  BTN_CART: '#HeaderMobile__CartBtn',
  CART_WRAP: '#CartMobileWrap',
}

const $root = $('html, body')
const $menuWrap = $(SELECTORS.MENU_WRAP)
const $cartWrap = $(SELECTORS.CART_WRAP)

const $btnMenu = $(SELECTORS.BTN_MENU)
const $btnCart = $(SELECTORS.BTN_CART)

const MENU_ACTIVE_CLASS = 'nav-mobile--is-active'
const CART_ACTIVE_CLASS = 'cart-mobile--is-active'

const BTN_MENU_ACTIVE_CLASS = 'header-mobile__btn-menu--is-active'
const BTN_CART_ACTIVE_CLASS = 'header-mobile__btn-cart--is-active'

const SCROLL_LOCK_CLASS = 'not-scrollable'

let menuIsOpen = $menuWrap.hasClass(MENU_ACTIVE_CLASS) || false
let cartIsOpen = $cartWrap.hasClass(CART_ACTIVE_CLASS) || false

export default () => {
  $(document).on('click touch keyup', (event) => {
    if (event.type === 'keyup' && event.keyCode == KEYCODE_ESC) {
      if (cartIsOpen) {
        closeCart()
      }

      if (menuIsOpen) {
        closeMenu()
      }
      return
    }

    const isRelevantToMenu =
      Boolean($(event.target).parents(SELECTORS.MENU_WRAP).length) ||
      Boolean($(event.target).parents(SELECTORS.BTN_MENU).length)

    const isMenuBtn = $(event.target).is($btnMenu) || $(event.target).closest(SELECTORS.BTN_MENU).is($btnMenu)
    const isCartBtn = $(event.target).closest(SELECTORS.BTN_CART).is($btnCart)

    if (isCartBtn) {
      event.preventDefault()
      toggleCart()
    }

    if (isMenuBtn) {
      toggleMenu()
      return
    }

    if (menuIsOpen && !isRelevantToMenu) {
      closeMenu()
      return
    }
  })
}

export function openMenu() {
  $menuWrap.addClass(MENU_ACTIVE_CLASS)
  $btnMenu.addClass(BTN_MENU_ACTIVE_CLASS)
  $root.addClass(SCROLL_LOCK_CLASS)
  menuIsOpen = true
  if (cartIsOpen) {
    closeCart()
  }
}

export function closeMenu() {
  $menuWrap.removeClass(MENU_ACTIVE_CLASS)
  $btnMenu.removeClass(BTN_MENU_ACTIVE_CLASS)
  menuIsOpen = false
  $root.removeClass(SCROLL_LOCK_CLASS)
  setTimeout(() => setActiveMenuTier('root'), ANIMATION_DURATION)
}

export function toggleMenu() {
  if (menuIsOpen === true) {
    closeMenu()
  } else {
    openMenu()
  }
}

export function openCart() {
  $cartWrap.scrollTop(0)
  $cartWrap.addClass(CART_ACTIVE_CLASS)
  $btnCart.addClass(BTN_CART_ACTIVE_CLASS)
  cartIsOpen = true
  $root.addClass(SCROLL_LOCK_CLASS)
}

export function closeCart() {
  $cartWrap.removeClass(CART_ACTIVE_CLASS)
  $btnCart.removeClass(BTN_CART_ACTIVE_CLASS)
  cartIsOpen = false
  $root.removeClass(SCROLL_LOCK_CLASS)
}

export function toggleCart() {
  if (cartIsOpen === true) {
    closeCart()
  } else {
    openCart()
  }
}



// WEBPACK FOOTER //
// ./header-mobile.js